import { defineFeatureFlags } from '@packages/feature-flags';

/**
 * Names are camelCase. `enabled` sets the value on each stand, the stand is `APP_STAND` of the
 * container (@packages/runtime-config). On dev and test a value can be overridden in the devtools panel.
 *
 * Example:
 *   newProfile: {
 *     description: 'New profile page, [FRT-123](https://tracker.yandex.ru/FRT-123)',
 *     enabled: { dev: true, test: false, prod: false },
 *   },
 */
export const featureFlagDefinitions = defineFeatureFlags({
  registrationEmailVerification: {
    description: '[FRT-8555](https://tracker.yandex.ru/FRT-8555)',
    enabled: { dev: true, test: true, prod: true },
  },
  ratingsAndReviews: {
    description: '[FRT-8349](https://tracker.yandex.ru/FRT-8349)',
    enabled: { dev: false, test: false, prod: false },
  },
  companyRatingInHeader: {
    description: '[FRT-8461](https://tracker.yandex.ru/FRT-8461)',
    enabled: { dev: true, test: true, prod: true },
  },
  vacancyTariffs: {
    description: '[FRT-8460](https://tracker.yandex.ru/FRT-8460)',
    enabled: { dev: false, test: false, prod: false },
  },
});
